import omit from 'lodash/omit';
import BaseImage, {ImageLoaderProps, ImageProps as NextImageProps} from 'next/image';
import {FC} from 'react';

interface ImageProps extends Omit<NextImageProps, 'layout'> {
    src: string;
    alt: string;
}

export const Image: FC<ImageProps> = ({src, alt, ...props}) => {
    omit(props, ['layout']);
    return <ImageOptimized src={src} alt={alt} {...props} />;
};

const customLoader = ({src, width, quality}: ImageLoaderProps): string => {
    const isSslHttp = src.startsWith('http') || src.startsWith('https');
    const shopUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT?.replace(/\/$/, '');
    const finalSrc = isSslHttp ? src : `${shopUrl}/${src}`;

    // Validate image type
    const allowedImageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
    const url = new URL(finalSrc);
    const extension = url.pathname.split('.').pop()?.toLowerCase() ?? '';

    if (!allowedImageTypes.includes(extension)) {
        return src;
    }

    // Convert to WebP format
    return `https://cdn.kidsplaza.vn/_next/image?url=${encodeURIComponent(finalSrc)}&w=${width}&q=${
        quality || 100
    }&fm=webp`;
};

// export const ImageOptimized: FC<ImageProps> = ({ src, alt, ...props }) => {
//   return <BaseImage src={src} alt={alt} loader={customLoader} {...props} />;
// };
export const ImageOptimized: FC<ImageProps> = ({src, alt, ...props}) => {
    // return <BaseImage src={src} alt={alt} loader={customLoader} {...props} />;
    return <BaseImage src={src} alt={alt} {...props} unoptimized />;
};
